import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

export function NotFoundPage() {
  const navigate = useNavigate();

  // The host serves every unknown path as a 200 with this SPA shell, so the
  // HTTP status can't say "not found". Tag the page noindex instead, otherwise
  // crawlers treat junk URLs as real pages (soft 404s).
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        px: { xs: 3, md: 8 },
        pt: { xs: 4, md: 6 },
        pb: { xs: 4, md: 8 },
      }}
    >
      <Typography variant="h1" sx={{ color: "primary.main", lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h2">Page introuvable</Typography>
      <Typography variant="body1" color="text.secondary" maxWidth={520}>
        Cette page n'existe pas ou a été déplacée. Retournez à l'accueil pour
        continuer votre visite.
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={() => {
          navigate("/");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        Retour à l'accueil
      </Button>
    </Box>
  );
}
